// extracted by mini-css-extract-plugin
module.exports = {"addNew":"_AddCircle_addNew__1dXtr","circle":"_AddCircle_circle__AhWCC"};